import React from 'react';
import styled from 'styled-components';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import Video from '@zocdoc-frontend-common/assets-icons/Video';
import { noticeMedium, white } from '@zocdoc-mezzanine/foundations-colors';

export function VideoVisitBannerView({
    professionalName = 'Your doctor',
    virtualVisitType,
}) {
    let text;
    if (virtualVisitType === 'ZocdocVideoVisit') {
        text =
            'After you book your visit, we will email you a link for your visit and some tips on getting set up.';
    } else {
        text = `${professionalName} will contact you with instructions on how to join your video visit.`;
    }

    return (
        <Banner data-test="video-visit-banner">
            <h1>
                <VideoCircle>
                    <VideoIcon />
                </VideoCircle>
                You are booking a video visit
            </h1>
            <h2>{text}</h2>
        </Banner>
    );
}

const Banner = styled.div`
    position: relative;
    background: #e9dcf6;
    padding: 16px;
    font-family: ${FontFamily.SharpSansMedium};
    font-size: 14px;
    line-height: 20px;
    h1 {
        font-family: ${FontFamily.SharpSansSemibold};
        font-size: 18px;
        line-height: 30px;
        padding-bottom: 6px;
    }
    margin-top: 25px;
`;

const VideoCircle = styled.div`
    background: ${noticeMedium};
    color: ${white};
    font-size: 12px;

    border-radius: 50%;

    height: 24px;
    width: 24px;

    display: inline-block;
    margin-right: 6px;
`;
const VideoIcon = styled(Video)`
    position: relative;
    height: 16px;
    width: 16px;
    top: 1px;
    left: 5px;
`;
